import {ApolloLink} from '@apollo/client';
import type {unstable_InternalOperation as InternalOperation} from '@sail/data';
import transformDocumentWithRest from './transformDocumentWithRest';

// This link transform the GraphQL Document. It is a kind of patch to the
// original transformer function located in @sail/data that transforms composed
// fragments to a root query. We need to patch this logic as the Rest logic
// needs to have updated the values inside `queryName`. This is not
// schema-agnostic and therefore cannot be placed in @sail/data core.
export default function createRestTransformLink(): ApolloLink {
  return new ApolloLink(function restTransformLink(
    operation: InternalOperation,
    forward,
  ) {
    const operationContext = operation.getContext();
    if (operationContext.graphQlOperation?.type !== 'COMPOSITION_QUERY') {
      return forward(operation);
    }

    const transformedQuery = transformDocumentWithRest(operation.query);

    operation.query = transformedQuery;

    return forward(operation);
  });
}
